/* STORMROCK — barre d'achat collante de la fiche produit.
   19/09/2026.

   Ce que corrige ce fichier : au chargement, la barre collante affichait le
   prix du PREMIER format alors que la fiche en présélectionne un autre.
   Sur White Widow, 11,25 € sous un produit vendu 108,75 €, avec un prix barré
   faux lui aussi.

   Pourquoi : snippets/sticky-add-to-cart.liquid rend son prix en Liquid depuis
   « selected_or_first_available_variant », donc le premier format tant que
   l'URL ne porte pas de ?variant=. Sa mise à jour en JavaScript va chercher
   « .product-card__button-price--new » dans la page produit rechargée ; au
   chargement initial elle n'aboutit pas, et le prix reste celui du rendu.

   La réparation : le bouton principal de la fiche, lui, porte toujours le bon
   prix, y compris après un changement de format puisque le thème le re-rend.
   On recopie donc ses deux prix dans la barre, une première fois au chargement
   puis à chaque fois qu'il change. Source unique, aucun calcul ici.

   snippets/sticky-add-to-cart.liquid n'est pas modifié. */
(function () {
  'use strict';

  var SEL_BOUTON = '[data-type="add-to-cart-form"] [type="submit"]';

  function sync() {
    var barre = document.querySelector('.sticky-add-to-cart');
    var principal = document.querySelector(SEL_BOUTON);
    if (!barre || !principal) { return false; }

    var prix = principal.querySelector('[data-atc-price]');
    var cible = barre.querySelector('.product-card__button-price--new');
    if (!prix || !cible) { return false; }

    var valeur = prix.textContent.trim();
    if (!valeur) { return false; }
    if (cible.textContent.trim() !== valeur) { cible.textContent = valeur; }

    /* Prix barré. Sur la fiche il est présent mais masqué par sr-prix.css
       (.product-details .atc-cmp) : son texte reste lisible. Absent, on cache
       la case au lieu d'y laisser le montant d'un autre format. */
    var compare = principal.querySelector('.atc-cmp');
    var cibleCompare = barre.querySelector('.price-item-collection_atc');
    if (cibleCompare) {
      var boite = cibleCompare.closest('.price-item--regular');
      var texte = compare ? compare.textContent.trim() : '';
      if (texte) {
        if (cibleCompare.textContent.trim() !== texte) { cibleCompare.textContent = texte; }
        if (boite) { boite.style.display = ''; }
      } else if (boite) {
        boite.style.display = 'none';
      }
    }
    return true;
  }

  /* Deux sources de mutation à surveiller.
     1. La fiche : le thème re-rend son bouton à chaque changement de format.
     2. La barre elle-même : son propre script va chercher le prix en AJAX et
        écrit APRÈS nous, avec une valeur périmée quand la requête n'aboutit
        pas. En l'observant, c'est nous qui repassons en dernier.
     Aucune boucle : sync() n'écrit que si les valeurs diffèrent, donc la
     mutation que nous provoquons trouve tout aligné et s'arrête là. */
  var enAttente = false;
  function planifier() {
    if (enAttente) { return; }
    enAttente = true;
    setTimeout(function () { enAttente = false; sync(); }, 80);
  }

  function surveiller(noeud) {
    if (!noeud || noeud.dataset.srPrixVu) { return; }
    noeud.dataset.srPrixVu = '1';
    new MutationObserver(planifier).observe(noeud, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function observer() {
    var principal = document.querySelector(SEL_BOUTON);
    surveiller(principal && principal.closest('[data-type="add-to-cart-form"]'));
    surveiller(document.querySelector('.sticky-add-to-cart'));
  }

  function demarrer() {
    if (!document.querySelector('.sticky-add-to-cart')) { return; }

    var essais = 0;
    var minuteur = setInterval(function () {
      essais += 1;
      var fait = sync();
      if (fait) { observer(); }
      if (fait || essais >= 24) { clearInterval(minuteur); }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();

/* ===========================================================================
   Réassurance en une ligne, sur téléphone — posé le 20/09/2026

   Ce bloc n'a rien à voir avec le prix collant qui précède : il loge ici parce
   que, sur ce magasin, l'API de thème n'accepte d'écrire que les fichiers de
   `assets/`, jamais une section ni un gabarit. Ce fichier-ci est déjà chargé sur
   l'accueil ; c'était le seul moyen d'y faire entrer du JavaScript.

   Rôle : recopier les pavés de la section réassurance autant de fois qu'il le
   faut pour que la ligne soit pleine en permanence, puis la faire glisser vers
   la droite, image par image. La mise en forme est dans `sr-reassurance.css`.

   --- POURQUOI `left` ET NON UNE ANIMATION CSS `transform` ---------------------
   Une animation de `transform` promeut la ligne en couche composée. Le
   navigateur rastérise alors cette couche à une résolution inférieure à celle de
   l'écran puis l'agrandit : les traits fins — un texte de 12 px, une icône en
   filaire — s'étalent et virent au gris, alors que les aplats restent justes.
   La bande paraît recouverte d'un voile noir. C'est exactement ce que Fabien a
   signalé quatre fois, et aucune feuille de style n'était en cause : l'audit
   complet (masque, filtre, opacité, dégradé, fusion, pseudo-éléments, sur la
   section, tous ses ancêtres et tous ses descendants) rendait zéro suspect.
   En déplaçant `left` image par image, il n'y a pas de couche : chaque image est
   redessinée à la résolution de l'écran, et le texte reste aussi net qu'un texte
   immobile. C'est plus de travail pour le processeur, mais la bande est petite
   et le défilé s'arrête dès qu'elle sort de l'écran ou que l'onglet passe en
   arrière-plan.
   -----------------------------------------------------------------------------

   LA REGLE QUI COMPTE POUR LES COPIES. Le pas de boucle vaut une série de pavés.
   Pour que l'écran soit plein en permanence, il faut que la ligne mesure au
   moins « une série + une largeur d'écran » — sinon, au rembobinage, la fin de
   la ligne est déjà passée et on voit du noir. D'où un nombre de copies calculé,
   et non fixé à un : une série fait environ 700 px, ce qui suffit sur un
   téléphone de 375 px mais pas sur un écran de 749 px.

   Les largeurs sont arrondies au pixel entier avant le clonage, et `left` est
   toujours un entier : chaque pavé tombe ainsi sur la même phase sous-pixel, et
   les quatre sont rendus à l'identique. Sans cela, l'un paraît allumé et les
   autres éteints, sans qu'aucune règle ne le demande.

   Au-dessus de 749 px, tout est retiré : l'ordinateur retrouve sa grille.
   =========================================================================== */
(function () {
  'use strict';

  var CIBLE = 'section_DfjnC3';   // la section « REASSURANCE Mobile »
  var VITESSE = 46;               // pixels par seconde — le bandeau du haut en fait 40
  var SEUIL = 749;                // au-dessus, on ne touche à rien

  var section = null;
  var rangees = null;             // les rangées d'origine, jamais clonées deux fois
  var parSerie = 0;               // nombre de pavés dans une série
  var copies = 0;                 // nombre de séries ajoutées
  var saut = 0;                   // le pas de boucle, en pixels entiers
  var x = 0;                      // position courante, de `saut` vers 0
  var image = null;               // l'identifiant de la boucle d'animation
  var grille = 1;                 // le pas d'affichage : un pixel physique
  var dernier = 0;                // horodatage de l'image précédente
  var visible = true;             // la bande est-elle a l'écran ?
  var doigt = false;              // le visiteur a-t-il le doigt dessus ?

  function conteneur() {
    return section && section.querySelector('.section-content-wrapper');
  }

  function pavesDe(noeud) {
    return [].slice.call(noeud.querySelectorAll('.group-block-content > .group-block'));
  }

  function retenir(w) {
    if (rangees) return true;
    var enfants = [].slice.call(w.children).filter(function (n) {
      return n.nodeType === 1 && !n.hasAttribute('data-sr-rea-copie');
    });
    if (!enfants.length) return false;
    var n = pavesDe(w).length;
    if (!n) return false;
    rangees = enfants;
    parSerie = n;
    return true;
  }

  /* La taille du texte se pose en ligne et en `important` : le thème la déclare
     dans une couche `@layer`, et pour les déclarations `important` l'ordre des
     couches est inversé — un `!important` écrit hors couche, dans
     sr-reassurance.css, perdrait. Les largeurs aussi, puisque cette même feuille
     impose `width: auto !important` pour défaire la demi-largeur du thème. */
  function figerLargeurs(w) {
    var p = pavesDe(w).slice(0, parSerie);
    p.forEach(function (n) {
      [].slice.call(n.querySelectorAll('.text-block, .text-block p')).forEach(function (e) {
        e.style.setProperty('font-size', '12px', 'important');
        e.style.setProperty('line-height', '16px', 'important');
      });
      n.style.removeProperty('width');
    });
    void w.offsetWidth;                       // on force le recalcul avant de mesurer
    var larges = p.map(function (n) { return Math.ceil(n.getBoundingClientRect().width); });
    p.forEach(function (n, i) { n.style.setProperty('width', larges[i] + 'px', 'important'); });
  }

  function libererLargeurs(w) {
    pavesDe(w).forEach(function (n) {
      n.style.removeProperty('width');
      [].slice.call(n.querySelectorAll('.text-block, .text-block p')).forEach(function (e) {
        e.style.removeProperty('font-size');
        e.style.removeProperty('line-height');
      });
    });
  }

  function ajouterSerie(w) {
    rangees.forEach(function (rangee) {
      var copie = rangee.cloneNode(true);
      copie.setAttribute('aria-hidden', 'true');
      copie.setAttribute('data-sr-rea-copie', '');
      // une copie est un décor : elle ne doit pas être atteignable au clavier
      [].slice.call(copie.querySelectorAll('a, button, input, select, textarea')).forEach(function (n) {
        n.setAttribute('tabindex', '-1');
      });
      w.appendChild(copie);
    });
    copies += 1;
  }

  function retirerSerie(w) {
    var faites = [].slice.call(w.children).filter(function (n) {
      return n.nodeType === 1 && n.hasAttribute('data-sr-rea-copie');
    });
    faites.slice(-rangees.length).forEach(function (n) { w.removeChild(n); });
    copies -= 1;
  }

  /* l'écart entre le premier pavé et son homologue de la série suivante */
  function mesurerSerie(w) {
    var p = pavesDe(w);
    if (p.length < parSerie * 2) return 0;
    var pas = p[parSerie].getBoundingClientRect().left - p[0].getBoundingClientRect().left;
    return pas > 0 ? Math.round(pas) : 0;
  }

  /* ---------------------------------------------------------------- le défilé */

  function pas(maintenant) {
    image = null;
    var w = conteneur();
    if (!w || !saut) return;
    var ecart = dernier ? Math.min(maintenant - dernier, 100) : 0;  // un onglet revenu de loin ne saute pas
    dernier = maintenant;
    if (!doigt) {
      x -= VITESSE * ecart / 1000;            // vers la droite
      while (x <= 0) x += saut;               // la boucle, sans couture
    }
    poser(w);
    relancer();
  }

  /* Pas de test sur `document.hidden` : certains navigateurs integres — dont le
     volet d'apercu — declarent la page cachee alors qu'ils dessinent bel et
     bien, et le defile resterait fige. Le navigateur suspend deja
     `requestAnimationFrame` de lui-meme quand l'onglet passe en arriere-plan ;
     c'est suffisant, et c'est lui qui a raison. */
  /* On arrondit au pixel PHYSIQUE de l'ecran, pas au pixel CSS. Un telephone
     affiche deux ou trois pixels physiques par pixel CSS : arrondir au pixel CSS
     ne laissait que 46 pas par seconde, ce qui se voit — le mouvement saccade
     legerement. Au pixel physique, c'est 92 ou 138 pas par seconde, donc fluide,
     et chaque position tombe malgre tout pile sur un pixel de la dalle : le
     texte reste aussi net qu'immobile. */
  function poser(w) {
    w.style.left = -(Math.round(x * grille) / grille) + 'px';
  }

  function relancer() {
    if (image !== null) return;
    if (!visible || !saut) return;
    image = window.requestAnimationFrame(pas);
  }

  function arreter() {
    if (image !== null) { window.cancelAnimationFrame(image); image = null; }
    dernier = 0;
  }

  var guetteur = null;
  function guetter() {
    if (guetteur || !window.IntersectionObserver || !section) return;
    guetteur = new IntersectionObserver(function (entrees) {
      visible = entrees[0].isIntersecting;
      if (visible) relancer(); else arreter();
    });
    guetteur.observe(section);
  }

  /* ---------------------------------------------------------------- la mise en place */

  function regler() {
    if (!section) section = document.querySelector('[id$="__' + CIBLE + '"]');
    if (!section) return;
    var w = conteneur();
    if (!w) return;

    if (window.innerWidth > SEUIL) { demonter(w); return; }
    if (!retenir(w)) return;

    // les largeurs d'abord : les copies doivent hériter de largeurs entières
    if (copies === 0) { figerLargeurs(w); ajouterSerie(w); }
    var mesure = mesurerSerie(w);
    if (!mesure) return;

    // autant de copies qu'il en faut pour couvrir l'écran en plus de la série
    var voulues = Math.max(1, Math.ceil(window.innerWidth / mesure));
    while (copies < voulues) ajouterSerie(w);
    while (copies > voulues) retirerSerie(w);

    if (saut !== mesure) { saut = mesure; x = saut; }
    grille = Math.max(1, Math.round(window.devicePixelRatio || 1));
    w.setAttribute('data-sr-rea', '');
    poser(w);

    // mouvement réduit : la ligne reste posée, le doigt la fait glisser
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      w.style.left = '0px';
      return;
    }
    guetter();
    relancer();
  }

  function demonter(w) {
    w = w || conteneur();
    arreter();
    saut = 0; x = 0;
    if (!w || !copies) return;
    [].slice.call(w.children).forEach(function (n) {
      if (n.nodeType === 1 && n.hasAttribute('data-sr-rea-copie')) w.removeChild(n);
    });
    copies = 0;
    libererLargeurs(w);
    w.removeAttribute('data-sr-rea');
    w.style.removeProperty('left');
  }

  var minuteur = null;
  function plusTard() {
    clearTimeout(minuteur);
    minuteur = setTimeout(function () {
      // la largeur des pavés dépend de l'écran : on refait la mesure de zéro
      var w = conteneur();
      if (w && copies) demonter(w);
      regler();
    }, 150);
  }

  function demarrer() {
    regler();
    // les polices arrivent après : la largeur des pavés change, on remesure
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(plusTard);
    window.addEventListener('load', plusTard);
    window.addEventListener('resize', plusTard);
    window.addEventListener('orientationchange', plusTard);
    document.addEventListener('visibilitychange', function () {
      // au retour, l'écart de temps est écrêté dans `pas()` : pas de saut
      if (!document.hidden) { dernier = 0; relancer(); }
    });
    // une pression du doigt met le défilé en pause
    ['pointerdown', 'touchstart'].forEach(function (e) {
      document.addEventListener(e, function (ev) {
        if (section && section.contains(ev.target)) doigt = true;
      }, { passive: true });
    });
    ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach(function (e) {
      document.addEventListener(e, function () { doigt = false; }, { passive: true });
    });
    // l'éditeur de thème réinjecte la section : on repart de zéro
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.id && e.target.id.indexOf(CIBLE) !== -1) {
        arreter();
        section = null; rangees = null; parSerie = 0; copies = 0; saut = 0;
        if (guetteur) { guetteur.disconnect(); guetteur = null; }
        plusTard();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
